import css from "./Code.module.css";
import { ReactNode } from "react";

export function Code(props: { children: ReactNode }) {
  return (
    <div className={css.root}>
      <div className={css.title}>Code</div>
      <div className={css.body}>
        <code>{props.children}</code>
      </div>
    </div>
  );
}
